package com.neurobs.ccabserver.administrator.view

import com.neurobs.ccab.NoiseMetrics
import com.neurobs.ccabserver.administrator.view.NoiseMetricsView.TestNoiseMetrics
import com.neurobs.js.view.{Container, Gui}
import com.neurobs.js.dom.DOMViewElement._
import scalatags.JsDom.all._

class NoiseMetricsView {
	private val status = span(style := "display:none;").render

	def set(metrics: Option[TestNoiseMetrics]): Unit = {
		metrics match {
			case Some(m) =>
				val pwrRounded = Math.round(m.metrics.pwr * 10.0) / 10.0
				val snrRounded = Math.round(m.metrics.snr * 10.0) / 10.0
				val values = s"(${m.testDisplayName},$pwrRounded,$snrRounded)"
				NoiseMetricsView.status(m.metrics) match {
					case NoiseMetricsView.NoiseStatus.LowVolume =>
						status.innerHTML = s"Low volume $values"
						status.className = "controller-session-noise-status-low-volume"
					case NoiseMetricsView.NoiseStatus.Noisy =>
						status.innerHTML = s"Noisy $values"
						status.className = "controller-session-noise-status-noisy"
					case NoiseMetricsView.NoiseStatus.Ok =>
						status.innerHTML = s"Noise Ok $values"
						status.className = "controller-session-noise-status-ok"
				}
				status.style.display = "inline-block"
			case None =>
				status.style.display = "none"
		}
	}

	def container: Container = status
}

object NoiseMetricsView
{
	case class TestNoiseMetrics(testDisplayName: String, metrics: NoiseMetrics)

	object NoiseStatus extends Enumeration {
		val Ok, Noisy, LowVolume = Value
	}
	def status(metrics: NoiseMetrics): NoiseStatus.Value = {
		if (metrics.pwr <= -50) {
			NoiseStatus.LowVolume
		} else if (metrics.snr <= 99) {
			NoiseStatus.Noisy
		} else {
			NoiseStatus.Ok
		}
	}
}